// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-sortable {
  color: #888;
}
body.no-footer {
  padding-bottom: 0;
}
body.no-footer #public-footer-wrapper {
  display: none;
}
body.no-footer .body-content {
  padding: 0;
}
body.content-scroll .admin-page-body {
  padding-bottom: 0;
}
body.content-scroll .body-content {
  overflow-y: hidden;
}
.custom-vSelect.v-select:not(.vs--open) .vs__selected + .vs__search {
  height: 0;
  margin: 0;
}
.custom-vSelect .vs__dropdown-toggle,
.custom-vSelect.vs__dropdown-menu {
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
}
.custom-vSelect.vs__dropdown-menu {
  min-width: max-content !important;
}
.custom-vSelect.vs__dropdown-menu[data-popper-placement="top-start"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./admin/pages/Search/Search.3.vue","webpack://./../Search.3.vue"],"names":[],"mappings":"AACA;EACI,WAAA;ACAJ;ADEA;EAEQ,iBAAA;ACDR;ADDA;EAKQ,aAAA;ACDR;ADJA;EAQQ,UAAA;ACDR;ADIA;EAEQ,iBAAA;ACHR;ADCA;EAMQ,kBAAA;ACJR;ADSI;EACI,SAAA;EACA,SAAA;ACPR;ADGA;;EAQQ,yBAAA;EACA,qBAAA;ACPR;ADSI;EACI,iCAAA;ACPR;ADQQ;EACI,0BAAA;EACA,uBAAA;EACA,0CAAA;ACNZ","sourcesContent":["\n.icon-sortable {\n    color: #888;\n}\nbody.no-footer {\n    & {\n        padding-bottom: 0;\n    }\n    #public-footer-wrapper {\n        display: none;\n    }\n    .body-content {\n        padding: 0;\n    }\n}\nbody.content-scroll {\n    .admin-page-body {\n        padding-bottom: 0;\n    }\n\n    .body-content {\n        overflow-y: hidden;\n    }\n}\n.custom-vSelect {\n    // avoid white space issue with v-select\n    &.v-select:not(.vs--open) .vs__selected + .vs__search {\n        height: 0;\n        margin: 0;\n    }\n    .vs__dropdown-toggle,\n    &.vs__dropdown-menu {\n        border: 1px solid #ced4da;\n        border-radius: 0.2rem;\n    }\n    &.vs__dropdown-menu {\n        min-width: max-content !important;\n        &[data-popper-placement=\"top-start\"] {\n            border-radius: 4px 4px 0 0;\n            border-top-style: solid;\n            box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);\n        }\n    }\n}\n",".icon-sortable {\n  color: #888;\n}\nbody.no-footer {\n  padding-bottom: 0;\n}\nbody.no-footer #public-footer-wrapper {\n  display: none;\n}\nbody.no-footer .body-content {\n  padding: 0;\n}\nbody.content-scroll .admin-page-body {\n  padding-bottom: 0;\n}\nbody.content-scroll .body-content {\n  overflow-y: hidden;\n}\n.custom-vSelect.v-select:not(.vs--open) .vs__selected + .vs__search {\n  height: 0;\n  margin: 0;\n}\n.custom-vSelect .vs__dropdown-toggle,\n.custom-vSelect.vs__dropdown-menu {\n  border: 1px solid #ced4da;\n  border-radius: 0.2rem;\n}\n.custom-vSelect.vs__dropdown-menu {\n  min-width: max-content !important;\n}\n.custom-vSelect.vs__dropdown-menu[data-popper-placement=\"top-start\"] {\n  border-radius: 4px 4px 0 0;\n  border-top-style: solid;\n  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
